import * as React from 'react';
import { SyntheticEvent } from 'react';
import { ErrorOption, FieldError, RegisterOptions } from 'react-hook-form';

/**
 * General Props for form input
 */
export interface InputProps {
	name: string;
	id?: string;
	onChangeCustom?: (e: SyntheticEvent) => void;
	isLogin?: boolean;
	title?: string;
	classNameTitle?: string;
	classNameInput?: string;
	classNameIcon?: string;
	colorIcon?: string;
	className?: string;
	register: (
		name: string,
		RegisterOptions?: RegisterOptions
	) => {
		onChange: (e: SyntheticEvent) => void;
		onBlur: (e: SyntheticEvent) => void;
		name: string;
		ref: React.Ref<any>;
	};
	customPlaceholder?: string;
	rules?: Record<string, unknown>;
	resizable?: boolean;
	rows?: number;
	markAsRequired?: boolean;
	isDirty?: boolean;
	iconRight?: string | undefined;
	iconLeft?: string | undefined;
	setValueInput?: any;
	labelVisible?: boolean;
	primary?: boolean;
	rightClick?: () => void;
	leftClick?: () => void;
	error?: any;
	errors?: FieldError;
	setError?: (name: string, error: ErrorOption) => void;
	initialPhoneValue?: string;
	disabled?: boolean;
	tooltipLabel?: string;
	dateRange?: 'before-current' | 'after-current' | 'all';
	startYear?: number;
	endYear?: number;
	classNameContainer?: string;
	classNameTrigger?: string;
	classNameContainerInput?: string;
	classNameLabel?: string;
	customErrorMessage?: string;
	hideErrorMessage?: boolean;
	textAreaRef?: React.MutableRefObject<HTMLTextAreaElement | null>;
	autoResize?: boolean;
	withOutErrorIcon?: boolean;
	additionalInfoTitle?: string;
	showCount?: boolean;
}
